(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('.announcement-bar-wrapper[data-discount-code]');
    if (!wrapper) return;

    var code = wrapper.dataset.discountCode;
    if (!code) return;

    var storageKey = 'announcement-bar:discount-applied:' + code;
    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (e) {}

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () {
        try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('bean-store-locator'); if(!root) return;
  function fmt(s,o){for(var k in o)s=s.split('__'+k+'__').join(o[k]);return s}
  var input=root.querySelector('#bsl-q'), status=root.querySelector('.bsl-status'),
      empty=root.querySelector('.bsl-empty'), eSec=root.querySelector('[data-edamama]'),
      cSec=root.querySelector('[data-consign]'), accs=root.querySelectorAll('[data-retailer]'),
      cards=root.querySelectorAll('.bsl-card'), t;
  function run(){
    var q=input.value.trim().toLowerCase(), total=0;
    var terms=q.split(/\s+/).filter(Boolean);
    function hit(el,pre){var s=((pre||'')+' '+(el.getAttribute('data-search')||'')+' '+el.textContent).toLowerCase();for(var i=0;i<terms.length;i++){if(s.indexOf(terms[i])<0)return false}return true}
    var ec=0; cards.forEach(function(c){var m=hit(c);c.classList.toggle('bsl-hidden',!m);if(m)ec++});
    eSec.classList.toggle('bsl-hidden',ec===0); total+=ec;
    var cc=0;
    accs.forEach(function(a){
      var n=0, rn=a.querySelector('.bsl-acc__title').textContent; a.querySelectorAll('.bsl-row').forEach(function(r){var m=hit(r,rn);r.classList.toggle('bsl-hidden',!m);if(m)n++});
      var c=a.querySelector('[data-count]'), tot=+c.getAttribute('data-total');
      c.textContent=q?fmt(root.dataset.storesFiltered,{COUNT:n,TOTAL:tot}):fmt(root.dataset.storesCount,{COUNT:tot});
      a.classList.toggle('bsl-hidden',n===0);
      if(q){a.open=n>0}else{a.open=false}
      cc+=n;
    });
    cSec.classList.toggle('bsl-hidden',cc===0); total+=cc;
    empty.style.display=total?'none':'block';
    status.textContent=q?(total?fmt(total===1?root.dataset.matchOne:root.dataset.matchOther,{COUNT:total,QUERY:input.value.trim()}):''):'';
  }
  input.addEventListener('input',function(){clearTimeout(t);t=setTimeout(run,120)});
})();

  } catch(e) { console.error(e); }
})();
})();
